import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";

// Material
import CircularProgress from "@material-ui/core/CircularProgress";

// Actions
import { getMediaItem } from "../../state/media/actions";
import { getMediaItem as getStatementItem } from "../../state/statements/actions";
import { getMediaItem as getMediaPerpetratorItem } from "../../state/mediaPerpetrators/actions";
import { getMedicalRecordsItem } from "../../state/medicalRecords/actions";
import { toggleSnack } from "../../state/snackbar/actions";

// Config
import { getMediaType } from "../../config/values";
import { snackbarTypes } from "../../config/snackbar";

// Components
import MediaItemImage from "../MediaItemImage";

const views = {
  mediaPerpetrators: {
    action: getMediaPerpetratorItem
  },
  media: {
    action: getMediaItem
  },
  medicalRecords: {
    action: ({ mediaId, ...props }) =>
      getMedicalRecordsItem({ recordId: mediaId, ...props })
  },
  statements: {
    action: getStatementItem
  }
};

const parseStatementToMedia = statement => {
  const result = {
    id: statement.id,
    filename: `${statement.id}.pdf`,
    resourceURLs: {
      document: statement.reportUri
    },
    type: "Document",
    isProcessing: !!statement.reportUri
  };

  return result;
};

const getData = data => {
  return data && data.templateSnapshot ? parseStatementToMedia(data) : data;
};

const GalleryItem = ({ mediaId, caseId, view, onFail }) => {
  const dispatch = useDispatch();
  const { galleryItems } = useSelector(s => s[view]);

  const data = galleryItems && getData(galleryItems[mediaId]);

  useEffect(() => {
    if (!data) {
      dispatch(
        views[view].action({
          caseId,
          mediaId,
          onFail: () => {
            dispatch(toggleSnack({ type: snackbarTypes.ERROR }));
            onFail();
          }
        })
      );
    }
  }, [caseId, data, dispatch, mediaId, view]);

  if (!data) return <CircularProgress />;

  const type = getMediaType(data.type);

  const props = {};
  if (type === "video") {
    props.hls = data.resourceURLs.hlsStream;
    props.dash = data.resourceURLs.dashStream;
  } else {
    props.src =
      data.resourceURLs && (data.resourceURLs[type] || data.resourceURLs.url);
  }

  return <MediaItemImage type={type} filename={data.filename} {...props} />;
};

GalleryItem.propTypes = {
  caseId: PropTypes.string.isRequired,
  mediaId: PropTypes.string.isRequired,
  view: PropTypes.string.isRequired,
  onFail: PropTypes.func.isRequired
};

export default GalleryItem;
